import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { IPos } from './pos';
import { PosesService } from './poses.service';
import { PosesListComponent } from './poses-list.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
// import * as myGlobals from './../global';
// import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
// import { SucursalesService } from '../sucursales/sucursales.service';
// import { ISucursal } from '../sucursales/sucursal';
import { MonitorService } from '../shared/monitor.service';
import { Merchant } from '../shared/merchant.model';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-poses',
  templateUrl: './poses.component.html',
  styleUrls: ['./poses.component.sass']
})
export class PosesComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'POSES';

  posesList: IPos[] = [];
  filteredPosesList: IPos[];
  errorMessage = '';
  currentPg = 1;
  searchStatus = '';
  searchMerchant: any;

  posesComboList: Observable<IPos[]> = this.service.getPoses();
  merchantList: Observable<Merchant[]> = this.merchantService.getMerchants();

  constructor(
    public service: PosesService,
    public parent: PosesListComponent,
    public router: Router,
    public spinnerService: NgxSpinnerService,
    public merchantService: MonitorService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    // $('#menu-catalogos').click();
    $('a[rel=pos]').addClass('selected');
  }

  onUpdateByFilter() {
    // console.log('filterPos: searchMerchant: [', this.searchMerchant.id, ']');
    // console.log('filterPos: searchStatus: [', this.searchStatus, ']');
    this.filteredPosesList = this.posesList.filter(pos => this.applyFilterOverPos(pos));
  }

  applyFilterOverPos(pos: IPos) {
    let showByMerchantFilter = false;
    let showByStatusFilter = false;

    if (this.searchMerchant != null) {
      const selectedMerchant = this.searchMerchant.id;

      if (selectedMerchant === 0) {
        showByMerchantFilter = true;
      } else if (pos.merchantId === selectedMerchant) {
        showByMerchantFilter = true;
      }
    } else {
      showByMerchantFilter = true;
    }

    if (this.searchStatus.trim() === '') {
      showByStatusFilter = true;
    } else if (pos.status.toString() === this.searchStatus) {
      showByStatusFilter = true;
    }

    if (showByStatusFilter && showByMerchantFilter) {
      return true;
    }

    return false;
  }

  newPos(): void {
    this.parent.showEditPos = false;
    this.parent.showPoses = false;
    this.parent.showAddPos = true;
  }

  ngOnInit(): void {
    console.log('ngOnInit: Entrando...');
    this.spinner();
    this.service.getPoses().subscribe(
      res => {
        console.log('ngOnInit: res: ', res);
        this.posesList = res;
        this.filteredPosesList = this.posesList;
        console.log('ngOnInit: filteredPosesList ready');
      },
      err => this.httpErrorValidator.validateError(err)
    );
  }

  edit(elemento, index: number) {
    console.log('Entrando: index: ', index);
    console.log('Entrando: id: ', elemento);
    this.parent.editnumber = elemento.id;
    this.parent.showPoses = false;
    this.parent.showAddPos = false;
    this.parent.showEditPos = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=pos]').removeClass('selected');
  }
}
